import { ReactNode } from "react";

type FooterProps = { children?: ReactNode | undefined; bottom: ReactNode };

export const Footer: React.FC<FooterProps> = ({ bottom, children }) => {
  const footerClassName = "min-w-screen w-full bg-blue-primary pt-8 pb-5 px-0 md:pt-16 md:pb-10";
  const bottomClassName = "md:mx-12 mx-6 lg:mx-16";

  return (
    <footer className={footerClassName}>
      <div className={bottomClassName}>{bottom}</div>
    </footer>
  );
};
